/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * List of strings.
 * @export
 * @interface PredicateStringValues
 */
export interface PredicateStringValues {
  /**
   *
   * @type {Array<string>}
   * @memberof PredicateStringValues
   */
  values?: Array<string>;
}

/**
 * Check if a given object implements the PredicateStringValues interface.
 */
export function instanceOfPredicateStringValues(value: object): value is PredicateStringValues {
  return true;
}

export function PredicateStringValuesFromJSON(json: any): PredicateStringValues {
  return PredicateStringValuesFromJSONTyped(json, false);
}

export function PredicateStringValuesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PredicateStringValues {
  if (json == null) {
    return json;
  }
  return {
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function PredicateStringValuesToJSON(json: any): PredicateStringValues {
  return PredicateStringValuesToJSONTyped(json, false);
}

export function PredicateStringValuesToJSONTyped(
  value?: PredicateStringValues | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    values: value['values'],
  };
}
